import axios, { AxiosResponse } from "axios";
import TrainingCourseSessionView from "../../models/views/education/TrainingCourseSessionView";
import BaseService from "../base/BaseService";

export default class TrainingCourseSessionService extends BaseService {
    getByCourseNoteId(courseNoteId: number): Promise<TrainingCourseSessionView[]> {
        return axios.get(`/TrainingCourseSession/Student`, {
            params: { courseNoteId }
        }).then(function (response: AxiosResponse<TrainingCourseSessionView[], any>) {
            return response.data;
        });
    }
}
